import Service from "../Service";

const resource = "HmnMyMassiveRecruitment/";

export default {
  pagination(dtr, requestID) {
    return Service.post(resource + "myCampaigns", null, {
      params: { requestID: requestID },
    }).then(response => {
      return {
        ...response,
        data: {
          data: response.data,
          recordsTotal: response.data ? response.data.length : 0,
          recordsFiltered: response.data ? response.data.length : 0
        }
      };
    });
  },
  myCampaigns(requestID) {
    return Service.post(resource + "myCampaigns", null, {
      params: { requestID: requestID },
    });
  },
  paginationApplicants(dtr, requestID) {
    const filter = dtr.filter || {};
    const mrcID = filter.MrcID || 0;
    const pstID = filter.PstID || null;
    return Service.post(resource + "myApplicants", null, {
      params: { mrcID: mrcID, requestID: requestID, pstID: pstID },
    }).then(response => {
      return {
        ...response,
        data: {
          data: response.data,
          recordsTotal: response.data ? response.data.length : 0,
          recordsFiltered: response.data ? response.data.length : 0
        }
      };
    });
  },
  myApplicants(mrcID, requestID, pstID = null) {
    return Service.post(resource + "myApplicants", null, {
      params: { mrcID: mrcID, requestID: requestID, pstID: pstID },
    });
  },
  myPositions(mrcID, requestID) {
    return Service.post(resource + "myPositions", null, {
      params: { mrcID: mrcID, requestID: requestID },
    });
  },
};
